import { Select } from "antd";
import type { RefSelectProps } from "antd/lib/select";
import { observer } from "mobx-react-lite";
import { type CSSProperties, forwardRef, useEffect, useMemo } from "react";
import { useIntl } from "react-intl";

import { useGlobalStore } from "@/stores";

type TProps = {
  value?: number;
  onChange?: (value?: number) => void;
  style?: CSSProperties;
  disabled?: boolean;
};

function RubricatorSelector(
  { value, onChange, style, disabled }: TProps,
  ref: React.Ref<RefSelectProps>,
) {
  const { gameCategoryRubricatorStore } = useGlobalStore();
  const intl = useIntl();

  useEffect(() => {
    if (!gameCategoryRubricatorStore.rubricator.length) {
      void gameCategoryRubricatorStore.fetch();
    }
  }, [gameCategoryRubricatorStore]);

  const options = useMemo(
    () =>
      gameCategoryRubricatorStore.rubricator.map((item) => ({
        label: item.name,
        value: item.id,
      })),
    [gameCategoryRubricatorStore.rubricator],
  );

  const selectedValue = value ?? gameCategoryRubricatorStore.selectedId;

  const handleChange = (nextValue?: number) => {
    gameCategoryRubricatorStore.setSelectedId(nextValue);
    onChange?.(nextValue);
  };

  return (
    <Select
      ref={ref}
      placeholder={intl.formatMessage({
        defaultMessage: "Select rubricator",
      })}
      showArrow
      value={selectedValue}
      onChange={handleChange}
      options={options}
      style={style}
      disabled={disabled}
      filterOption={(input, option) =>
        String(option?.label ?? "")
          .toLowerCase()
          .includes(input.toLowerCase())
      }
      optionFilterProp="label"
    />
  );
}

export default observer(forwardRef(RubricatorSelector));
